import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { QueryFunctionContext } from '@tanstack/react-query';
import { Variables } from 'graphql-request';
import type { RemoveIndex } from 'graphql-request/build/esm/helpers';

import { datoClient } from 'services/api';

type GraphQLRequestVariable<V extends Variables> =
  V extends Record<string, never>
    ? [variables?: V]
    : keyof RemoveIndex<V> extends never // do we get an empty variables object?
      ? [variables?: V]
      : [variables: V];

export const datoRequester =
  <T = unknown, V extends Variables = Variables>(
    document: TypedDocumentNode<T, V>,
    ...variables: GraphQLRequestVariable<V>
  ) =>
  (ctx: QueryFunctionContext | undefined): Promise<T> =>
    datoClient({ preview: !!ctx?.meta?.preview }).request(
      document,
      ...variables,
    );
